import { ElementRef, Injectable } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';


@Injectable()
export class LcpHelper {

  static defaultListPlaceholderHTML: string = "<p><em>no results</em></p>"

  stopAllTyping: boolean
  isTypingElements: Element[] = []

  htmlFromRichText(richText: any) {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }
    return documentToHtmlString(richText);
  }

  backgroundImageFromMedia(media: any) {
    let url = this.urlFromMedia(media)
    if (!url) return
    return "url(" + url + ")"
  }

  srcFromMedia(media: any) {
    return this.urlFromMedia(media)
  }

  urlFromMedia(media: any) {
    let url
    try {
      url = 'https:' + media.fields.file.url
    } catch {
      return
    }
    // console.log('url:', url)
    return url
  }

  // https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
  // usage example:
  // var a = ['a', 1, 'a', 2, '1'];
  // var unique = a.filter(onlyUnique);
  onlyUnique(value: any, index: any, array: any) {
    return array.indexOf(value) === index;
  }

  getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
  }

  removeFromGroup(item: any, group: any) {
    const itemIndex = group.indexOf(item);
    console.log('ind', itemIndex, group, item)
    if (itemIndex > -1) { // only splice array when item is found
      group.splice(itemIndex, 1); // 2nd parameter means remove one item only
    }
    return group
  }

  // USAGE:
  // obj = { barney: { age: 36, active: true },
  //     fred: { age: 40, active: false },
  //     pebbles: { age: 1, active: true } }
  // findKey( obj,  x => x['active']); // returns 'barney'
  findKey(obj: any, fn: any) {
    if (!obj) return
    Object.keys(obj).find(key => fn(obj[key], key, obj));
  }

  percentageSequence(keys = 100) {
    let scale = keys/100
    let sequence = Array.from(Array(keys).keys()).map(i => parseFloat(((i+1) * (0.01 / scale)).toFixed(3)))
    // console.log('percentageSequence', sequence)
    return sequence
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  blockClass(block: any): any {
    try {
      return block.fields['slug'] || ''
    } catch { 
      return ''
    }
  }

  stopTypingElement(el: Element) {
    this.isTypingElements = this.isTypingElements.filter(i => i !== el)
  }

  async typeSentence(sentence: any, el: Element, params={}) {
    // @ts-ignore
    let delay = params['delay'] || 100
    let minDelay = params['minDelay'] || 10
    const letters = sentence.split("");
    let i = 0;
    // this.isTypingElements.push(el)
    while(i < letters.length && this.isTypingElements.includes(el)) {
      // if (!this.isTypingElements.includes(el)) return
      let randomizedDelay = Math.max(Math.random() * delay, minDelay);
      // console.log('randy', randomizedDelay)
      await this.waitForMs(randomizedDelay);
      this.typeLetter(el, letters[i], params)
      // $(el).append(letters[i]);
      i++
    }
    // this.stopTypingElement(el)
    // console.log('isTypingElements', this.isTypingElements)
    return
  }

  typeLetter(el: Element, letter: string, params={}) {
    // let el = this.createElement('span', letter)
    const shouldAnimate = params['shouldType']
    if (!shouldAnimate) return
    // let fadeIn = params['fade-in']
    // let container = el.nativeElement
    el.insertAdjacentHTML('beforeend', '<span>' + letter + '</span>')
    // if (params['fade-in'])
  }

  waitForMs(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  richTextToString(document) {
    return documentToPlainTextString(document)
  }

  linkFromBlock(block: any) {
    // console.log('TODO: linkFromBlock', block)
    const text = block.fields['linkText']
    const address = block.fields['linkAddress']
    if (!text || !address) return
    return {
      text: text,
      address: address
    }
  }
  
  // filterDisplay(filter: any) {
  //   filter.fields['name']
  // }
}